export const AIMO_PARKING_COMPANY_STATUS = {
  ALL: "all",
  ENABLED: "enabled",
  DELETED: "deleted",
} as const;

export type AimoParkingCompanyStatus = typeof AIMO_PARKING_COMPANY_STATUS[keyof typeof AIMO_PARKING_COMPANY_STATUS];
